import React from 'react';
import ReactDOM from 'react-dom/client';
import ThemeProvider from './styles/ThemeProvider';
import App from './App';

// @xyflow/react measures node size via ResizeObserver on every drag frame —
// fast enough dragging can outrun the browser's notification queue, which
// throws "ResizeObserver loop completed with undelivered notifications."
// It's harmless and self-recovering, but CRA's dev error overlay treats any
// uncaught window error as fatal and blocks the whole UI on it (looks like a
// crash; isn't one — this never appears in a production build). Catching the
// resulting window 'error' event is timing-fragile (webpack-dev-server's own
// overlay listener is registered before this module runs), so fix it at the
// source instead: debounce every ResizeObserver's callback so it can't fire
// fast enough to overrun. Must happen before any component (e.g. JourneyCanvas)
// mounts and constructs one, hence doing it here at the top of the entrypoint.
const NativeResizeObserver = window.ResizeObserver;
window.ResizeObserver = class DebouncedResizeObserver extends NativeResizeObserver {
  constructor(callback) {
    let timeoutId;
    super((...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(...args), 20);
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
